import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { t } from 'i18next';
import {
  Field, getFormValues, reduxForm, reset,
} from 'redux-form';
import putReduxDefaultSession from './actions';
import { routes } from '../../utils/constants';
import utils from '../../utils/utils';
import {
  ForgotPasswordContainer,
  FormButtonsContainer,
  FieldContainer,
  HeaderContainer,
  HeaderSignUpContainer,
  SignUp,
  StyledH2,
  FieldsContainer,
  LoginPageContainer,
  ContentContainer,
  LoginButton,
  LoginErrorLabel,
  ErrorIcon,
  ForgotPasswordSubContainer,
  LoginErrorContainer,
  FooterContainer,
  EmailContainer,
} from './css';
import { P, Div } from '../../theme/typographySitecore';
import { isEmail, isRequired } from '../../utils/validator';
import Row from '../ReactComponent/Row';
import ForgotPasswordModal from './ForgotPasswordModal';
import ForgotPasswordSuccessModal from './ForgotPasswordSuccessModal';
import { ForgotPasswordErrorModal } from './ForgotPasswordErrorModal';
import ActivationEmailModal from './ActivationEmailModal';
import { Divisions } from '../../utils/enums';
import { fetchAuthContent } from '../../actions/accounts';
import { apiLogin, sendActivationEmail } from './api';
import FurtherActions from './constants';
import TextInput from '../../lib/ui/form_elements/TextInput';
import PasswordInput from '../../lib/ui/form_elements/PasswordInput';

const formName = 'LoginForm';
const LoginFormFields = {
  username: 'username',
  password: 'password',
  division: 'division',
};

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loginErrorMessage: null,
      forgotPasswordModalIsOpen: false,
      forgotPasswordSuccessModalIsOpen: false,
      forgotPasswordErrorModalIsOpen: false,
      loginErrorFurtherActions: FurtherActions.NoFurtherActions,
      activationEmailModalIsOpen: false,
    };
  }

  setForgotPasswordModalIsOpen = (isOpen) => {
    this.setState({ forgotPasswordModalIsOpen: isOpen });
  };

  setForgotPasswordSuccessModalIsOpen = (isOpen) => {
    this.setState({ forgotPasswordSuccessModalIsOpen: isOpen });
  };

  setForgotPasswordFailureModalIsOpen = (isOpen) => {
    this.setState({ forgotPasswordErrorModalIsOpen: isOpen });
  };

  onCreateAccount = () => {
    window.location.href = routes.createAccount;
    return window.location.href;
  };

  onLoginSuccess = () => {
    const { fetchAuthContent } = this.props;

    fetchAuthContent();
  };

  onLoginFailed = (err) => {
    const { fields } = this.props;

    let errorMessage = fields.logInErrorMessage.value;
    let furtherActions = FurtherActions.NoFurtherActions;
    if (err) {
      const { status } = err;
      if (status) {
        switch (status) {
          case 401:
            errorMessage = fields.logInErrorMessage.value;
            furtherActions = FurtherActions.NoFurtherActions;
            break;
          case 400:
            errorMessage = fields.logInErrorMessage.value;
            furtherActions = FurtherActions.NoFurtherActions;
            break;
          case 403:
            errorMessage = fields.logInErrorMessage.value;
            furtherActions = FurtherActions.NoFurtherActions;
            break;
          case 412:
            errorMessage = fields.logInAccountInactiveErrorMessage.value;
            furtherActions = FurtherActions.AccountInactive;
            break;
          case 406:
            errorMessage = fields.logInAccountEmailNotValidatedErrorMessage.value;
            furtherActions = FurtherActions.EmailNotValidated;
            break;
          default:
            errorMessage = fields.logInAccountEmailNotValidatedErrorMessage.value;
            furtherActions = FurtherActions.EmailNotValidated;
            break;
        }
      }
    }

    this.setState({
      loginErrorMessage: errorMessage,
      loginErrorFurtherActions: furtherActions,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    // Clear loginErrorMessage...
    this.clearErrors();

    if (utils.isDisconnected) {
      const { putReduxDefaultSession } = this.props;
      putReduxDefaultSession();
      window.location.href = routes.viewUserDashboard;
    } else {
      const { formData } = this.props;

      const username = formData[LoginFormFields.username];
      const password = formData[LoginFormFields.password];
      const division = Divisions.Truckmate.code;

      apiLogin(this.onLoginSuccess, username, password, division, this.onLoginFailed);
    }
  };

  renderHeader = () => (
    <HeaderContainer>
      <StyledH2>{t('LogIn')}</StyledH2>
      <HeaderSignUpContainer>
        <Div field={t('OR')} />
        <SignUp onClick={this.onCreateAccount}>
          <Div field={t('SignUp')} />
        </SignUp>
      </HeaderSignUpContainer>
    </HeaderContainer>
  );

  openActivationEmailModal = () => {
    this.setState({ activationEmailModalIsOpen: true });
  };

  closeActivationEmailModal = () => {
    const { dispatch } = this.props;

    this.setState({ activationEmailModalIsOpen: false });
    this.clearErrors();
    dispatch(reset(formName));
  };

  activateEmail = (e) => {
    e.preventDefault();
    const { formData } = this.props;
    sendActivationEmail(this.openActivationEmailModal, formData[LoginFormFields.username]);
  };

  clearErrors = () => {
    this.setState({ loginErrorMessage: null, loginErrorFurtherActions: FurtherActions.NoFurtherActions });
  };

  renderError = () => {
    const { loginErrorMessage } = this.state;

    if (loginErrorMessage) {
      const { loginErrorFurtherActions } = this.state;

      return (
        <LoginErrorContainer>
          <LoginErrorLabel>
            <ErrorIcon />
            <div>
              {loginErrorMessage}
              {loginErrorFurtherActions === FurtherActions.EmailNotValidated
                && <a href="#" onClick={(e) => this.activateEmail(e)}>{t('LoginActivateAccount')}</a>}
            </div>
          </LoginErrorLabel>
        </LoginErrorContainer>
      );
    }

    return null;
  };

  renderForm = ({ isFormValid }) => {
    const { fields } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        {this.renderError()}

        <FieldsContainer>
          <Row>
            <FieldContainer>
              <Field
                name={LoginFormFields.username}
                label={t('EmailId')}
                component={TextInput}
                validate={[isRequired, isEmail]}
                onChange={this.clearErrors}
              />
            </FieldContainer>
          </Row>

          <Row>
            <FieldContainer>
              <Field
                name={LoginFormFields.password}
                label={t('Password')}
                component={PasswordInput}
                validate={[isRequired]}
              />
            </FieldContainer>
          </Row>
        </FieldsContainer>

        <ForgotPasswordContainer>
          <ForgotPasswordSubContainer onClick={() => this.setForgotPasswordModalIsOpen(true)}>
            <P field={fields.forgotPasswordText} />
          </ForgotPasswordSubContainer>
        </ForgotPasswordContainer>

        <FormButtonsContainer>
          <LoginButton type="submit" iconRightArrow isActive={isFormValid} disabled={!isFormValid}>
            {t('LogIn')}
          </LoginButton>
        </FormButtonsContainer>
      </form>
    );
  };

  renderFooter = () => {
    const { fields } = this.props;
    return (
      <FooterContainer>
        <Div field={fields.logInSupportTitle} />
        <EmailContainer>
          <Div field={fields.logInSupportSubTitle} />
          <Div field={fields.logInSupportEmail} />
        </EmailContainer>
      </FooterContainer>
    );
  };

  render() {
    const {
      forgotPasswordModalIsOpen, forgotPasswordSuccessModalIsOpen, activationEmailModalIsOpen, forgotPasswordErrorModalIsOpen,
    } = this.state;
    const { fields, valid } = this.props;

    return (
      <LoginPageContainer>

        <ForgotPasswordModal
          isOpen={forgotPasswordModalIsOpen}
          onClose={() => this.setForgotPasswordModalIsOpen(false)}
          onSuccess={() => {
            this.setForgotPasswordModalIsOpen(false);
            this.setForgotPasswordSuccessModalIsOpen(true);
          }}
          onFailure={() => {
            this.setForgotPasswordModalIsOpen(false);
            this.setForgotPasswordFailureModalIsOpen(true);
          }}
          parentFields={fields}
        />

        <ForgotPasswordSuccessModal
          isOpen={forgotPasswordSuccessModalIsOpen}
          onClose={() => this.setForgotPasswordSuccessModalIsOpen(false)}
          parentFields={fields}
        />

        <ForgotPasswordErrorModal
          openSetForgotPasswordModal={() => {
            this.setForgotPasswordModalIsOpen(true);
            this.setForgotPasswordFailureModalIsOpen(false);
          }}
          isOpen={forgotPasswordErrorModalIsOpen}
          onClose={() => this.setForgotPasswordFailureModalIsOpen(false)}
          parentFields={fields}
        />

        <ActivationEmailModal
          isOpen={activationEmailModalIsOpen}
          onClose={() => this.closeActivationEmailModal()}
          parentFields={fields}
        />

        <ContentContainer $desktop={7}>
          {this.renderHeader()}
          {this.renderForm({ isFormValid: valid })}
          {this.renderFooter()}
        </ContentContainer>

      </LoginPageContainer>
    );
  }
}

LoginForm.propTypes = {
  fields: PropTypes.object,
  formData: PropTypes.object,
  dispatch: PropTypes.func,
  fetchAuthContent: PropTypes.func,
  putReduxDefaultSession: PropTypes.func,
  valid: PropTypes.bool,
};

LoginForm = reduxForm({
  form: formName,
})(LoginForm);

const mapStateToProps = (state) => ({
  formData: getFormValues(formName)(state),
});

const mapDispatchToProps = (dispatch) => ({
  putReduxDefaultSession: () => dispatch(putReduxDefaultSession()),
  fetchAuthContent: () => dispatch(fetchAuthContent({ isFrontEndAuth: false, navToDashboard: true, invokeLayout: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);
